var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SurveyForm',{on:{"on-submit":_vm.addSurvey}})}
var staticRenderFns = []

export { render, staticRenderFns }